import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BoltDischargeIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M19.4531 19.2656L21.5869 17.1084L21.7637 16.9297L21.9414 17.1074L22.5664 17.7334L22.7432 17.9102L18.8721 21.7812L18.6953 21.959L18.5186 21.7812L14.8232 18.0869L14.6465 17.9102L15.627 16.9297L15.8037 17.1084L17.9365 19.2656V13.75H19.4531V19.2656ZM11.9502 10.0801H18.75L8.91016 21.2803H6.4502L8.0498 13.8604H1.25L11.0898 2.66016H13.5498L11.9502 10.0801ZM4.62988 12.4199H10.0098L8.46973 19.4199L15.3701 11.5205H9.99023L11.5303 4.52051L4.62988 12.4199Z" />
    </SvgIcon>
  );
});
